import { render, staticRenderFns } from "./AsyncComponentVcDemo.vue?vue&type=template&id=077bc3eb&scoped=true&"
import script from "./AsyncComponentVcDemo.vue?vue&type=script&lang=js&"
export * from "./AsyncComponentVcDemo.vue?vue&type=script&lang=js&"
import style0 from "./AsyncComponentVcDemo.vue?vue&type=style&index=0&id=077bc3eb&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077bc3eb",
  null
  
)

export default component.exports